import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { ListGroup } from 'react-bootstrap'

import NewToken from './NewToken'
import Token from './Token'

export default function PaymentTokenSelector({
  allowNewCard = false,
  selectedToken,
  selectToken,
  showWhenEmpty = false,
  tokens,
}) {
  if (!tokens.size && !showWhenEmpty) {
    return false
  }

  return (
    <div className="token-selector">
      <ListGroup>
        {allowNewCard && (
          <NewToken
            active={!selectedToken}
            selectToken={selectToken}
          />
        )}

        {tokens.map(token => (
          <Token
            key={token.get('uuid')}
            active={token.get('uuid') === selectedToken}
            token={token}
            selectToken={selectToken}
          />
        ))}
      </ListGroup>
    </div>
  )
}

PaymentTokenSelector.propTypes = {
  allowNewCard: Pt.bool,
  selectedToken: Pt.string,
  selectToken: Pt.func.isRequired,
  showWhenEmpty: Pt.bool,
  tokens: Ipt.orderedSet.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Payment/TokenSelector/index.jsx